'use client';

import React, { useState } from 'react';
import LoginForm from './LoginForm';
import SignUpForm from './SignUpForm';
import AuthBrandPanel from './AuthBrandPanel';

export default function AuthScreen() {
  const [tab, setTab] = useState<'login' | 'signup'>('login');

  return (
    <div className="min-h-screen bg-dark-base flex">
      {/* Left brand panel */}
      <AuthBrandPanel />

      {/* Right form panel */}
      <div className="flex-1 flex flex-col items-center justify-center px-6 py-12 lg:px-16 min-h-screen">
        <div className="w-full max-w-md animate-slide-up">
          {/* Logo mobile */}
          <div className="flex items-center gap-2 mb-10 lg:hidden">
            <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-brand-violet to-brand-violet-dark flex items-center justify-center">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path d="M9 2L14 7V15H4V7L9 2Z" stroke="#fff" strokeWidth="1.5" strokeLinejoin="round" fill="none"/>
                <line x1="6" y1="8" x2="12" y2="8" stroke="#06b6d4" strokeWidth="1.5" strokeLinecap="round"/>
                <line x1="5" y1="10.5" x2="13" y2="10.5" stroke="#06b6d4" strokeWidth="1.5" strokeLinecap="round"/>
                <line x1="6.5" y1="13" x2="11.5" y2="13" stroke="#06b6d4" strokeWidth="1.5" strokeLinecap="round"/>
              </svg>
            </div>
            <span className="font-semibold text-lg text-white tracking-tight">TrackLab</span>
          </div>

          {/* Tab switcher */}
          <div className="flex bg-dark-card rounded-xl p-1 mb-8 border border-dark-border">
            <button
              onClick={() => setTab('login')}
              className={`flex-1 py-2.5 text-sm font-medium rounded-lg transition-all duration-200 ${
                tab === 'login' ?'bg-brand-violet text-white shadow-neon-violet' :'text-gray-400 hover:text-gray-200'
              }`}
            >
              Sign In
            </button>
            <button
              onClick={() => setTab('signup')}
              className={`flex-1 py-2.5 text-sm font-medium rounded-lg transition-all duration-200 ${
                tab === 'signup' ?'bg-brand-violet text-white shadow-neon-violet' :'text-gray-400 hover:text-gray-200'
              }`}
            >
              Create Account
            </button>
          </div>

          {/* Form */}
          <div className="animate-fade-in" key={tab}>
            {tab === 'login' ? (
              <LoginForm onSwitchToSignup={() => setTab('signup')} />
            ) : (
              <SignUpForm onSwitchToLogin={() => setTab('login')} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}